<template>
	<div class="home-content-page">
		<div class="menu-navigation-box">
			<type-components></type-components>
			<div class="center-box">
				<el-carousel :interval="5000" arrow="always" height="386px" trigger="click">
					<el-carousel-item v-for="(item, index) in bannerList" :key="index">
						<img :src="item.imageUrl" @click="goPages(item);" />
					</el-carousel-item>
				</el-carousel>
			</div>
			<div class="right-box">
				<template v-if="hasLogin">
					<div class="top-box" @click="goOrder();">
						<div class="head-img-box">
							<img src="../../assets/images/head-img.png" />
						</div>
						<div class="name">{{ userInfo.nickname }}</div>
					</div>
					<div class="bottom-box">
						<div class="func-box" @click="goOrder();">
							<div class="func-img"><img src="../../assets/images/order4.png" /></div>
							<div class="func-name">全部订单</div>
						</div>
						<div class="func-box" @click="goOrder('000');">
							<div class="func-img width">
								<img src="../../assets/images/order1.png" />
								<div class="tag" v-if="orderGroups['000']">{{ orderGroups['000'] }}</div>
							</div>
							<div class="func-name">待付款</div>
						</div>
						<div class="func-box" @click="goOrder('101');">
							<div class="func-img width">
								<img src="../../assets/images/order5.png" />
								<div class="tag" v-if="orderGroups['101']">{{ orderGroups['101'] }}</div>
							</div>
							<div class="func-name">待发货</div>
						</div>
						<div class="func-box" @click="goOrder('301');">
							<div class="func-img">
								<img src="../../assets/images/order2.png" />
								<div class="tag" v-if="orderGroups['301']">{{ orderGroups['301'] }}</div>
							</div>
							<div class="func-name">已发货</div>
						</div>
						<div class="func-box" @click="goOrder('501');">
							<div class="func-img">
								<img src="../../assets/images/order3.png" />
								<div class="tag" v-if="orderGroups['501']">{{ orderGroups['501'] }}</div>
							</div>
							<div class="func-name">已收货</div>
						</div>
					</div>
				</template>
				<template v-else>
					<div class="no-login-content">
						<div class="title">漱玉优乐采欢迎您~</div>
						<div class="login-btn" @click="goLogin();">立即登录</div>
					</div>
				</template>
			</div>
		</div>
		<div class="product-special-box">
			<div class="special-box" v-for="item in productList" :key="item.id">
				<div class="special-name">
					<div class="title">{{ item.title }}</div>
					<div class="more" @click="goPages(item);">更多<i class="iconfont icon-PCgengduo"></i></div>
				</div>
				<div class="product-list-box" v-if="item.productDtos && item.productDtos.records">
					<product-components v-for="product in item.productDtos.records" :key="product.id" :product="product"
						@click="productClick"></product-components>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getHomeProductList
	} from '@/api/goods.js';
	import {
		getHomeBanner
	} from '@/api/home.js';
	import {
		getOrderGroups
	} from '@/api/order.js';
	import typeComponents from '@/components/typeComponents.vue';
	import productComponents from '@/components/productComponents.vue';
	import {
		mapGetters
	} from 'vuex';

	export default {
		components: {
			typeComponents,
			productComponents
		},
		data() {
			return {
				bannerList: [],
				productList: [],
				orderGroups: {}
			};
		},
		watch: {
			hasLogin(val) {
				if (!val) {
					this.getHomeBanner();
					this.getHomeProductList();
				}
				this.orderGroups = {};
			},
			'$store.state.userInfo.groupId'(val) {
				this.getHomeBanner();
				this.getHomeProductList();
				if (this.hasLogin) {
					this.getOrderGroups();
				}
			},
		},
		computed: {
			...mapGetters(['hasLogin', 'userInfo'])
		},
		beforeMount() {
			this.getHomeBanner();
			this.getHomeProductList();

			if (this.hasLogin) {
				this.getOrderGroups();
			}
		},
		methods: {
			goLogin() {
				this.$router.push('/login?redirect=' + this.$route.fullPath);
			},

			getOrderGroups() {
				getOrderGroups().then(res => {
					if (res && res.code == '0') {
						this.orderGroups = res.data;
					}
				});
			},

			productClick(data) {
				this.$router.push('/goodsDetail?id=' + data.productTypeCode);
			},

			getHomeBanner() {
				getHomeBanner().then(res => {
					if (res && res.code == 0) {
						this.bannerList = res.data;
					}
				});
			},

			getHomeProductList() {
				getHomeProductList().then(res => {
					if (res && res.code == 0) {
						this.productList = res.data;
					}
				});
			},

			goPages(item) {
				this.$router.push('/goodsList?pageFrom=special&id=' + item.id);
			},

			goOrder(tabName) {
				let url = '/order-list';

				if (tabName) {
					url = url + '?tabName=' + tabName;
				}

				this.$router.push(url);
			}
		},
	};
</script>

<style lang="scss" rel="stylesheet/scss">
	@import "@/assets/css/szui.scss";

	.home-content-page {
		.menu-navigation-box {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.center-box {
				margin: 0 10px;
				width: 720px;
				height: 386px;
				border-radius: 10px;
				overflow: hidden;
				cursor: pointer;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.right-box {
				width: 230px;
				height: 386px;
				background: #FFFFFF;
				border-radius: 10px;

				.top-box {
					display: flex;
					justify-content: center;
					align-items: center;
					flex-direction: column;
					width: 100%;
					height: 177px;
					cursor: pointer;

					.head-img-box {
						width: 55px;
						height: 55px;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.name {
						margin-top: 10px;
						font-size: 16px;
						font-weight: 400;
						color: $fontColor;
					}
				}

				.bottom-box {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					flex-wrap: wrap;
					height: 208px;
					border-top: 1px dashed #EDEFF2;

					.func-box {
						display: flex;
						justify-content: center;
						align-items: center;
						flex-direction: column;
						width: 33.3%;
						cursor: pointer;

						.func-img {
							position: relative;
							width: 21px;

							img {
								width: 100%;
							}

							.tag {
								position: absolute;
								top: -12px;
								left: 20px;
								padding: 0 6px;
								height: 16px;
								line-height: 16px;
								background: #F43232;
								border-radius: 8px;
								font-size: 13px;
								font-weight: 400;
								color: #FFFFFF;
							}
						}

						.width {
							width: 24px;
						}

						.func-name {
							margin-top: 8px;
							font-size: 13px;
							font-weight: 400;
							color: $fontColor;
						}
					}
				}

				.no-login-content {
					display: flex;
					justify-content: center;
					align-items: center;
					flex-direction: column;
					width: 100%;
					height: 100%;

					.title {
						line-height: 1;
						font-size: 18px;
						color: #262728;
					}

					.login-btn {
						display: flex;
						justify-content: center;
						align-items: center;
						margin-top: 30px;
						width: 120px;
						height: 40px;
						background: #FFCC00;
						border-radius: 20px;
						font-weight: bold;
						font-size: 14px;
						color: #262728;
						cursor: pointer;
					}
				}
			}
		}

		.product-special-box {
			.special-box {
				margin-top: 50px;

				.special-name {
					display: flex;
					justify-content: space-between;
					align-items: flex-end;

					.title {
						font-size: 26px;
						font-weight: bold;
						color: $fontColor;
					}

					.more {
						font-size: 14px;
						color: #606366;
						cursor: pointer;

						.icon-PCgengduo {
							margin-left: 6px;
							font-size: 12px;
							color: #606366;
						}
					}
				}

				.product-list-box {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					flex-wrap: wrap;

					.product-components {
						margin-right: 10px;
					}

					.product-components:nth-child(5n) {
						margin-right: 0;
					}
				}
			}
		}
	}
</style>